import React, {ReactNode} from 'react';
import './ListViewGroup.scss';

export interface ListViewGroupProps {
  title?: string;
  className?: string;
  flat?: boolean;
  children: ReactNode;
}

const ListViewGroup: React.FC<ListViewGroupProps> = ({ title, className, flat, children }) => {
  const classNames = ['listview-group', className];
  if (flat) {
    classNames.push('flat');
  }

  return (
      <li className={classNames.join(' ').trim()}>
        {title && (
            <div className="listview-group__title">{title}</div>
        )}
        <ol className="listview-group__items">
          {children}
        </ol>
      </li>
  );
};

export default ListViewGroup;
